import { render } from "./MarbelFooter.vue?vue&type=template&id=8bad15b4&scoped=true"
import script from "./MarbelFooter.vue?vue&type=script&lang=js"
export * from "./MarbelFooter.vue?vue&type=script&lang=js"

import "./MarbelFooter.vue?vue&type=style&index=0&id=8bad15b4&scoped=true&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bad15b4"]])

export default __exports__